import { MAIN_URL, REQUEST_URL } from "../../constant/ApplicationVariables";
import { axiosInstance } from "../useAxios/useAxios";

export const createRegressionPlan_API = async (body) => {
  try {
    const response = await axiosInstance.post(
      MAIN_URL.url + REQUEST_URL.createPlan,
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("createRegressionPlan error", error);
    throw error;
  }
};

// Update Regression Plan
export const updateRegressionPlan_API = async (body) => {
  try {
    const response = await axiosInstance.put(
      MAIN_URL.url + REQUEST_URL.updatePlan,
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log(response.data, "updateRegressionPlan response");
    return response.data; // Return only the backend response data
  } catch (error) {
    console.error("updateRegressionPlan error:", error);
    throw error; // Throw so the caller can handle it
  }
};

// Delete Regression Plan
export const deleteRegressionPlan_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.deletePlan,
      method: "DELETE",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "deleteRegressionPlan response");
    return response;
  } catch (error) {
    console.log(error, "deleteRegressionPlan error");
    return error;
  }
};

// Get Regression Plan Detail
export const getRegressionPlan_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.getPlan,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "getRegressionPlan response");
    return response;
  } catch (error) {
    console.log(error, "getRegressionPlan error");
    return error;
  }
};

export const listRegressionPlans_API = async (projectName) => {
  try {
    const response = await axiosInstance.get(
      MAIN_URL.url + REQUEST_URL.listPlans(projectName)
    );
    console.log(response, "listRegressionPlans response");
    return response;
  } catch (error) {
    console.error("listRegressionPlans error", error);
    throw error;
  }
};

// Execute Regression Plan
export const executeRegressionPlan_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.executePlan,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "executeRegressionPlan response");
    return response;
  } catch (error) {
    console.log(error, "executeRegressionPlan error");
    return error;
  }
};

// Execute Regression Plan with Boundary Mode
export const executeRegressionPlanWithBoundary_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.executePlan,
      method: "POST",
      data: {
        ...body,
        boundaryMode: body.boundaryMode || false
      },
      contentType: "application/json",
    });
    console.log(response, "executeRegressionPlanWithBoundary response");
    return response;
  } catch (error) {
    console.log(error, "executeRegressionPlanWithBoundary error");
    throw error;
  }
};

// Update Test Cases for a Regression Plan
export const updateTestCaseFiles_API = async ({
  planName,
  projectName,
  testCaseFiles,
}) => {
  try {
    const response = await axiosInstance.put(
      MAIN_URL.url + REQUEST_URL.updateTestCaseFiles,
      {
        planName,
        projectName,
        testCaseFiles,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(response.data, "updateTestCaseFiles_API response");
    return response.data; // Return backend response
  } catch (error) {
    console.error("updateTestCaseFiles_API error:", error);
    throw error;
  }
};

// Update Test Cases with Boundary Configuration
export const updateTestCaseFilesWithBoundary_API = async ({
  planName,
  projectName,
  testCaseFiles,
}) => {
  try {
    // Format test case files with boundary configuration
    const formattedTestCases = testCaseFiles.map(tc => ({
      testCaseCustomId: tc.customId || tc.testCaseCustomId,
      folderPath: tc.folderPath,
      elementFileId: tc.elementFile?.fileId || tc.elementFileId,
      applicationFileId: tc.applicationFile?.fileId || tc.applicationFileId,
      testDataFileId: tc.testDataFile?.fileId || tc.testDataFileId,
      scriptFileId: tc.scriptFile?.fileId || tc.scriptFileId,
      boundaryFieldCategorySelections: tc.boundaryEnabled ? (tc.boundaryFieldCategorySelections || tc.boundaryConfig || []) : []
    }));

    const response = await axiosInstance.put(
      MAIN_URL.url + REQUEST_URL.updateTestCaseFiles,
      {
        planName,
        projectName,
        testCaseFiles: formattedTestCases,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(response.data, "updateTestCaseFilesWithBoundary_API response");
    return response.data;
  } catch (error) {
    console.error("updateTestCaseFilesWithBoundary_API error:", error);
    throw error;
  }
};

// Get Test Case Script Fields for Boundary Configuration
export const getTestCaseScriptFields_API = async ({
  projectName,
  folderPath,
  customId,
  scriptFileId
}) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.getScriptFields || "/api/testcase/script-fields",
      method: "POST",
      data: {
        projectName,
        folderPath,
        customId,
        scriptFileId
      },
      contentType: "application/json",
    });
    console.log(response, "getTestCaseScriptFields_API response");
    return response;
  } catch (error) {
    console.log(error, "getTestCaseScriptFields_API error");
    return { data: { fields: [] } };
  }
};

// Save Boundary Configuration for a Test Case
export const saveBoundaryConfiguration_API = async ({
  planName,
  projectName,
  testCaseCustomId,
  boundaryFieldCategorySelections
}) => {
  try {
    const response = await axiosInstance.post(
      MAIN_URL.url + REQUEST_URL.saveBoundaryConfig || "/api/regression/boundary-config",
      {
        planName,
        projectName,
        testCaseCustomId,
        boundaryFieldCategorySelections
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(response, "saveBoundaryConfiguration_API response");
    return response;
  } catch (error) {
    console.error("saveBoundaryConfiguration_API error:", error);
    throw error;
  }
};

// Get Boundary Configuration for a Test Case
export const getBoundaryConfiguration_API = async ({
  planName,
  projectName,
  testCaseCustomId
}) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.getBoundaryConfig || "/api/regression/boundary-config",
      method: "POST",
      data: {
        planName,
        projectName,
        testCaseCustomId
      },
      contentType: "application/json",
    });
    console.log(response, "getBoundaryConfiguration_API response");
    return response;
  } catch (error) {
    console.log(error, "getBoundaryConfiguration_API error");
    return { data: { boundaryFieldCategorySelections: [] } };
  }
};